module.exports = __webpack_public_path__ + "img/IMG_4215_L_Wood_MockedUp.76377864.jpg";